import React from 'react';
import {
  NavigationContext,
  NavigationRouteContext,
  NavigationContainerRefContext,
} from '@react-navigation/native';

// `jest` n'existe pas dans le bundle webpack du navigateur. La barrel
// src/components/providers/index.js réexporte MockProviders, qui importe ce
// fichier — webpack ne peut pas le tree-shaker à cause des side-effects ESM.
// On fournit un substitut qui se comporte comme fn() (callable, retourne
// la valeur passée à .mockReturnValue / l'implémentation passée en argument).
const fn = (typeof globalThis !== 'undefined' && globalThis.jest && globalThis.jest.fn)
  ? globalThis.jest.fn
  : (impl) => {
      const f = (...args) => (typeof impl === 'function' ? impl(...args) : undefined);
      f.mockReturnValue = () => f;
      f.mockImplementation = () => f;
      return f;
    };

// A minimal mock navigation object that satisfies useNavigation() calls.
const mockNavigation = {
  navigate: fn(),
  goBack: fn(),
  dispatch: fn(),
  reset: fn(),
  setParams: fn(),
  setOptions: fn(),
  dismiss: fn(),
  isFocused: fn(() => true),
  canGoBack: fn(() => false),
  getParent: fn(() => ({
    navigate: fn(),
    goBack: fn(),
    dispatch: fn(),
    dismiss: fn(),
    reset: fn(),
    setParams: fn(),
    setOptions: fn(),
    isFocused: fn(() => true),
    canGoBack: fn(() => false),
    getParent: fn(() => undefined),
    getState: fn(() => undefined),
    addListener: fn(() => ({ remove: fn() })),
    removeListener: fn(),
    getId: fn(() => undefined),
  })),
  getState: fn(() => ({
    index: 0,
    key: 'stack-mock',
    routeNames: ['MockedScreen'],
    routes: [{ key: 'MockedScreen-mock', name: 'MockedScreen', params: {} }],
    stale: false,
    type: 'stack',
  })),
  addListener: fn(() => ({ remove: fn() })),
  removeListener: fn(),
  getId: fn(() => undefined),
};

// A minimal mock route object that satisfies useRoute() calls.
const mockRoute = {
  key: 'MockedScreen-mock',
  name: 'MockedScreen',
  params: {},
};

/**
 * MockedNavigator provides navigation context to components under test
 * without using an actual Stack Navigator. This avoids the act()-driven
 * useEffect flushes that the real @react-navigation/stack triggers, which
 * previously caused "Element type is invalid ... got: undefined" errors.
 *
 * Usage (unchanged):
 *   <MockedNavigationContainer component={() => <MyComponent />} />
 */
const MockedNavigator = ({ component: Component, params = {} }) => {
  const routeWithParams = params && Object.keys(params).length > 0
    ? { ...mockRoute, params }
    : mockRoute;

  return (
    <NavigationContainerRefContext.Provider value={mockNavigation}>
      <NavigationContext.Provider value={mockNavigation}>
        <NavigationRouteContext.Provider value={routeWithParams}>
          <Component />
        </NavigationRouteContext.Provider>
      </NavigationContext.Provider>
    </NavigationContainerRefContext.Provider>
  );
};

export default MockedNavigator;
